/* ------------------------------daktela chat -------------------------------*/
if (window.location.pathname.includes("contact-us")) {

var daktelaGuiConfig = {
    "server":"https://comfortclick.daktela.com/",
    "accessToken":"so0s2s9474rn371r32s9q5p68q829s3p"
};
// Create async script element
var daktelaWeb = null;
var daktelaScriptEl = document.createElement("script");
(function (attrs) { Object.keys(attrs).forEach(function (key) { daktelaScriptEl.setAttribute(key, attrs[key]); }); })
({"src":daktelaGuiConfig.server+"external/web/web.js", "type":"text/javascript", "async":true, "charset":"utf-8"});
daktelaScriptEl.onload = function() { if (!daktelaGui) return; daktelaWeb = new daktelaGui(); daktelaWeb.init(daktelaGuiConfig); };
document.getElementsByTagName("head")[0].appendChild(daktelaScriptEl);
}


/* ------------------------------Toggle password -------------------------------*/
document.addEventListener("click", function (event) {
  // Check if the clicked element is the 'eyeIcon'
  if (event.target.classList.contains("newFieldIcon-passwordEye")) {
    // Toggle the eye icon state
    event.target.classList.toggle("fa-eye");
    event.target.classList.toggle("fa-eye-slash");
    event.target.classList.toggle("showPassword");

    // Find the input element associated with this icon using the `toggle` attribute
    const inputSelector = event.target.getAttribute("toggle");
    if (inputSelector) {
      const input = document.querySelector(inputSelector);

      if (input) {
        // Toggle the input type between 'password' and 'text'
        input.type = input.type === "password" ? "text" : "password";
      }
    }
  }
});

const currentURL = window.location.href;
const pageTitle = document.title;

const shareButton = document.querySelector(".shareButton.main");
const shareGroup = document.querySelector(".groupButton2");

if (shareButton && shareGroup) {
  shareButton.addEventListener("click", function () {
    shareGroup.classList.toggle("active");
  });

  document.addEventListener("click", function (e) {
    if (!shareButton.contains(e.target) && !shareGroup.contains(e.target)) {
      shareGroup.classList.remove("active");
    }
  });
}

const shareButtons = document.querySelectorAll(".social-button");
shareButtons.forEach((button) => {
  button.addEventListener("click", function () {
    const platform = button.getAttribute("data-platform");

    let shareURL = "";
    switch (platform) {
      case "facebook":
        shareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}`;
        break;
      case "twitter":
        shareURL = `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentURL)}&text=${encodeURIComponent(pageTitle)}`;
        break;
      case "linkedin":
        shareURL = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentURL)}`;
        break;
      case "pinterest":
        shareURL = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(currentURL)}&description=${encodeURIComponent(pageTitle)}`;
        break;
      case "whatsapp":
        shareURL = `https://wa.me/?text=${encodeURIComponent(pageTitle + " " + currentURL)}`;
        break;
      case "email":
        shareURL = `mailto:?subject=${encodeURIComponent(pageTitle)}&body=${encodeURIComponent(currentURL)}`;
        break;
      case "copy":
        navigator.clipboard.writeText(currentURL);
        return;
    }

    if (shareURL) {
      window.open(shareURL, "_blank", "noopener,noreferrer");
    }
  });
});

// Account mobile nav
if (window.innerWidth <= 750) {
  const navTrigger = document.getElementById("navTrigger");
  const navList = document.querySelector(".profile-navigation");

  navList?.classList.add("hidden");

  navTrigger?.addEventListener("click", function () {
    navList.classList.toggle("hidden");
    navTrigger.classList.toggle("navTriggerActive");
  });

  const navListItems = document.querySelectorAll(".profile-navigation li a");
  navListItems?.forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      const content = this.innerHTML;
      navTrigger.innerHTML = content; // Update innerHTML of navTrigger
      navList.classList.add("hidden");
      navTrigger.classList.toggle("navTriggerActive");
    });
  });
}

// ----------------------  accordion on Collection page --------------
if(window.location.href.includes('/collection')){
  const triggers = document.querySelectorAll('.collection-hero__description .returnAccord-block_triggr');
  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault(); 
      const content = this.nextElementSibling;
      if (content.classList.contains('show')) {
        content.classList.remove('show');
        this.classList.add('collapsed');
      } else {
        content.classList.add('show');
        this.classList.remove('collapsed');
      }
    });
  });
}

const currentUrl = window.location.pathname;
// ✅ Remove OTP flag if not on /account or /login page
if (!currentUrl.includes("/account") && !currentUrl.includes("/login")) {
  sessionStorage.removeItem("hasShownOtp");
}

if (window.location.hash.includes('login-password')) {
  sessionStorage.setItem("hasShownOtp", true);
} else {
  const passwordSubmited = sessionStorage.getItem("passwordSubmited");
  if (!passwordSubmited) {
    sessionStorage.removeItem("hasShownOtp");
  }
}

document.querySelector('.dropdown-menu .login-button')?.addEventListener('click', (event) => {
  event.preventDefault();
  window.location.href = '/account/login';
  sessionStorage.removeItem("hasShownOtp");
})


// Live chat Trigger 
const liveChat = document.querySelectorAll('.live-chat__tigger');

liveChat?.forEach((each) => {
  each.addEventListener('click', () => {
    const chatButton = document.querySelector('.dw-button');
    if (chatButton) {
      chatButton.click();
    }
  })
})